import { selectCarRoute,insertCarRoute,updateCarRoute,deleteCarRoute } from "../../api/config/modules/RouteFile";

const state = {
    selectCarRoute: {},
    insertCarRoute: {},
    updateCarRoute: {},
    deleteCarRoute: {},
};

const mutations = {
  SET_SELECTROUTE: (state, selectCarRoute) => {
    state.selectCarRoute = selectCarRoute;
  },
  SET_INSERTROUTE: (state, insertCarRoute) => {
    state.insertCarRoute = insertCarRoute;
  },
  SET_UPDATEROUTE: (state, updateCarRoute) => {
    state.updateCarRoute = updateCarRoute;
  },
  SET_DELETEROUTE: (state, deleteCarRoute) => {
    state.deleteCarRoute = deleteCarRoute;
  },
};

const actions = {
  GET_SELECTROUTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarRoute(data)
        .then((res) => {
          commit("SET_SELECTROUTE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTROUTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertCarRoute(data)
        .then((res) => {
          commit("SET_INSERTROUTE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEROUTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateCarRoute(data)
        .then((res) => {
          commit("SET_UPDATEROUTE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEROUTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteCarRoute(data)
        .then((res) => {
          commit("SET_DELETEROUTE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
